import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { searchBy, sortBy } from '../features/jobs/jobSlice'

export default function Filter() {
    const dispatch = useDispatch();

    function handleSortChange(event) {
        console.log("dispatching sort by", event.target.value)
        dispatch(sortBy(event.target.value));
    }
    const handleSearchChange = (event) => {
        dispatch(searchBy(event.target.value));
    };
    return (<div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="lws-section-title">All Available Jobs</h1>
        <div className="flex gap-4">
            <div className="search-field group flex-1">
                {/* <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i> */}
                <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon group-focus-within:text-blue-500" />
                <input type="text" placeholder="Search Job" className="search-input" id="lws-searchJob" onChange={handleSearchChange} />
            </div>
            <select id="lws-sort" name="sort" autocomplete="sort" className="flex-1" onChange={handleSortChange}>
                <option value="">Default</option>
                <option value="low">Salary (Low to High)</option>
                <option value="high">Salary (High to Low)</option>
            </select>
        </div>
    </div>
    )
}
